import MobileLayout from './MobileLayout';
export default MobileLayout;